import React, { useEffect, useRef } from "react";
import { fireAdsConversion } from "../../utils/adsConversionUtils";

// Wraps a step in the direct quote flow so its Google Ads conversion fires
// once each time the step is shown. StepFlowNavigate clones the step element
// with the flow callbacks (onStepComplete, showPrevious and so on), so this
// wrapper forwards every prop except `step` to the wrapped component.
//
// The ref keeps the event to one per step: React StrictMode runs mount
// effects twice in development and the ref survives that. Each use in
// QuoteFlow.js also carries a key, so moving between two wrapped steps
// remounts the wrapper; the effect keys on the step slug as a second guard.
const AdsConversionStep = ({ step, children, ...flowProps }) => {
  const firedForStep = useRef(null);

  useEffect(() => {
    if (firedForStep.current === step) return;
    firedForStep.current = step;
    fireAdsConversion(step);
  }, [step]);

  return React.cloneElement(children, flowProps);
};

export default AdsConversionStep;
